module.exports = __webpack_public_path__ + "static/media/xl_uni.ed12c533.png";